
//import { addMessage } from '@/services/messages'

export default {
  props: ['index', 'user']
}
